import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Define window interface extension for TypeScript
declare global {
  interface Window {
    dataLayer?: any[];
  }
}

export const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Only track if consent has been granted
    const hasConsent = localStorage.getItem('cookieConsent') === 'accepted';
    
    if (hasConsent && typeof window !== 'undefined' && window.dataLayer) {
      // Add a slight delay to ensure GTM has processed consent
      setTimeout(() => {
        // Ensure dataLayer is still available when the timeout executes
        if (window.dataLayer) {
          // Push custom event that triggers your GA4 tag
          window.dataLayer.push({
            event: 'fire_page_view_after_consent',
            page_title: document.title,
            page_location: window.location.href,
            page_path: location.pathname,
            debug_mode: true // ensures GA4 DebugView picks it up
          });
          
          // Debugging log in development
          if (process.env.NODE_ENV !== 'production') {
            console.log('[RouteTracker] Page view event fired:', location.pathname);
          }
        }
      }, 500);
    }
  }, [location]); // This effect runs on every route change
  
  return null; // This component doesn't render anything
}; 